/**
 *
 */
(function() {
    'use strict';
    angular.module('cbl.mitomanager.wa').service('MitomLoggerSrvc', [
        '$http',
        function($http) {
            /** Constants */
            this.SEVERE = 'SEVERE';
            this.WARNING = 'WARNING';
            this.INFO = 'INFO';
            this.CONFIG = 'CONFIG';
            this.FINE = 'FINE';
            this.FINER = 'FINER';
            this.FINEST = 'FINEST';

            const LEVELS = [
                this.FINEST,
                this.FINER,
                this.FINE,
                this.CONFIG,
                this.INFO,
                this.WARNING,
                this.SEVERE
            ];

            /** Default value */
            this.loggerLevelString = this.FINEST;

            /** Livello di log */
            this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);

            /**
             * Setup iniziale del service. Lanciato sull' app run
             *
             * @param baseLevel
             */
            this.setupLogger = (baseLevel) => {
                if (LEVELS.indexOf(baseLevel) !== -1) {
                    this.loggerLevelString = baseLevel;
                }
                this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
            };

            /**
             * Controlla se il livello di log è abilitato
             *
             * @param level Il log level
             * @return {boolean}
             */
            this.levelEnabled = (level) => {
                return this.loggerLevel <= LEVELS.indexOf(level);
            };

            /**
             * Recupera il payload e formatta il messaggio
             *
             * @param logPayload Il payload dell' errore
             * @return {string}
             */
            this.formattaMessaggio = (logPayload) => {
                let message = '';
                if (typeof logPayload === 'string') {
                    return logPayload;
                }

                if (Object.prototype.toString.call(logPayload) === '[object Array]') {
                    for (let idx in logPayload) {
                        if (typeof logPayload[idx] === 'string') {
                            message += ' ' + logPayload[idx];
                        } else {
                            message += ' ' + JSON.stringify(logPayload[idx]);
                        }
                    }
                } else {
                    message += JSON.stringify(logPayload);
                }
                return message;
            };

            /**
             * Invia il log al backend
             *
             * @param controller Il nome del controller
             * @param type Il livello di Log
             * @param message Il messaggio dell' errore
             */
            this.log = (controller, type, message) => {
                message = this.formattaMessaggio(message);

                const level = LEVELS.indexOf(type);

                if (level < this.loggerLevel) {
                    return;
                }

                $http({
                    method: 'POST',
                    url: appSrvc.getApi('REST.GENERAL.LOG'),
                    data: {
                        level: type,
                        msg: message,
                        ctrl: controller
                    }
                });
            };
        }
    ]);
})();